import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { categoryServiceApi } from './services/categoryServiceApi';
import { subCategoryServiceApi } from './services/subCategoryServiceApi';
import { chapterServiceApi } from './services/chapterServiceApi';
import { questionServiceApi } from './services/QuestionServiceApi';
import { providerServiceApi } from './services/providerServiceApi';
import { adsServiceApi } from './services/adsServiceApi';
import { userServiceApi } from './services/userServiceApi';
import { notificationServiceApi } from './services/notificationServiceApi';
import { featureServiceApi } from './services/featureServiceApi';

export const store = configureStore({
  reducer: {
    [userServiceApi.reducerPath]: userServiceApi.reducer,
    [categoryServiceApi.reducerPath]: categoryServiceApi.reducer,
    [subCategoryServiceApi.reducerPath]: subCategoryServiceApi.reducer,
    [chapterServiceApi.reducerPath]: chapterServiceApi.reducer,
    [questionServiceApi.reducerPath]: questionServiceApi.reducer,
    [providerServiceApi.reducerPath]: providerServiceApi.reducer,
    [adsServiceApi.reducerPath]: adsServiceApi.reducer,
    [notificationServiceApi.reducerPath]: notificationServiceApi.reducer,
    [featureServiceApi.reducerPath]: featureServiceApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(userServiceApi.middleware,categoryServiceApi.middleware, subCategoryServiceApi.middleware, chapterServiceApi.middleware, questionServiceApi.middleware, providerServiceApi.middleware, adsServiceApi.middleware, notificationServiceApi.middleware, featureServiceApi.middleware),
});

setupListeners(store.dispatch);